// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__pWecL","label":"Labeled_label___1u6h","divider":"Labeled_divider__2uvF7"};